import React from "react";
import { makeStyles } from "tss-react/mui";
import { Typography, Grid } from "@mui/material";
import SubQuestionDetails from "./SubQuestionDetails";

import parse from "html-react-parser";

const useStyles = makeStyles()((theme) => ({
  questionHeading: {
    marginTop: 15,
    textAlign: "justify",
  },
}));

const QuestionDetails = (props) => {
  const { classes } = useStyles();
  const question = props.question;
  const subQuestions = props.subQuestions;

  return (
    <React.Fragment>
      {question.questionHeading !== "" && (
        <Grid item xs={12}>
          <div>
            <Typography className={classes.questionHeading} variant="body2">
              {question.questionHeading}
            </Typography>
          </div>
        </Grid>
      )}
      {question.questionDescription !== "" && (
        <Grid item xs={12}>
          <div>
            <Typography>{parse(question.questionDescription)}</Typography>
          </div>
        </Grid>
      )}
      {subQuestions.length > 0 &&
        subQuestions.map((subQuestion) => {
          return subQuestion.questionId === question.questionId ? (
            <SubQuestionDetails
              key={subQuestion.subQuestionId}
              question={question}
              subQuestion={subQuestion}
              formCompleted={props.formCompleted}
              answer={
                props.answers && props.answers.filter((answer) => answer.subQuestionId === subQuestion.subQuestionId)
              }
            />
          ) : null;
        })}
    </React.Fragment>
  );
};

export default QuestionDetails;
